export default function WhyUs() {
  const features = [
    {
      icon: 'ri-plane-line',
      title: 'أختار القطع بنفسي من مصادر موثوقة',
      description: 'كل منتج يمر بمعايير دقيقة للجودة والأصالة'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'ذوق راقٍ بعيد عن التكرار',
      description: 'قطع مميزة تعكس شخصيتك الفريدة'
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'ثقة وتجربة عميل حقيقية',
      description: 'رضاك هو أولويتي في كل تفصيلة'
    },
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#C9A88A] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            لماذا Luxury Products by Maram ؟
          </h2>
          <div className="w-24 h-1 bg-[#D4AF7A] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-8 rounded-2xl bg-[#F8F6F0] hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-[#D4AF7A] rounded-full">
                <i className={`${feature.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#3D3D3D] mb-3">
                {feature.title}
              </h3>
              <p className="text-[#3D3D3D]/70 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
